export default __webpack_public_path__ + "static/media/icon-documents.d417525a.svg";